import React, { forwardRef } from 'react';
import Page from '../../components/page';
import PictureSlider from '../../components/picture-slider';
import Me from './me.jpg';
 
let pictures = [
    {
        source: Me
    },
    {
        element: (<React.Fragment>
            <p>Ik ben Elsbeth van Asselt. Woon in Uddel met mijn lieve man en 3 prachtige schatten van kinderen! Sinds 2010 werk ik voor mijzelf in de bloemen. Nadat ik 4 jaar een bloemenwinkel heb gehad werk ik sinds 2014 vanuit huis.</p>
            <p>Bloemen zijn mijn passie, ik krijg er energie van en vind het heerlijk om mensen gelukkig te kunnen maken. De wensen van de klant uitwerken in het bloemwerk.</p>
            <p>Een feestelijke dag, een moeilijke periode in het leven
            .. Bijzonder en fijn dat ik mijn steentje mag bijdragen.. De ene keer een prachtige aankleding de andere keer het leed verzachten.. Het mooie vind ik dat in elke fase van het leven, iedere gebeurtenis of bijzonder moment, bloemen toegepast kunnen worden. Het is al 10 jaar mijn passie!
             Ondanks drukke, moeilijke en zorgelijke tijden gaf het mij kracht om door te gaan! Dank jullie wel allemaal voor het vertrouwen in mij.. Ik hoop nog veel mooie creaties te mogen maken!</p>
            </React.Fragment>)
    },
    {
        element: (<React.Fragment></React.Fragment>)
    }
];

const About = forwardRef((props, ref) => {
    return (<Page header="Over mij" ref={ref}>
    
    <PictureSlider items={pictures} numberOfCards={2} autoPlay={false} />
    
    </Page>);
});

export default About;